<template>
    <div class="mapDiv">
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
        ></loading>
        <div v-show="isLoadingmy " style="background: rgba(0,0,0,0.5); position: fixed; display: flex;justify-content:center;align-items:center;z-index: 1000001;left: 0;top: 0;height: 100%;width: 100%;">
            <img src="static/img/loader.gif" v-show="isLoadingmy" style="max-width:100px;"/>
        </div>
        <!-- Actual Map object on screen.   -->
        <div class="map-header-avatar">
            <md-button class="avatar-button" @click="">
                <md-avatar v-if="currentUser.avatar" class="md-avatar-icon">
                    <img :src="getImageSrc(currentUser.avatar)">
                </md-avatar>
                <md-avatar v-else class="md-avatar-icon blue">
                    {{ getUserInitials(currentUser) }}
                </md-avatar>
            </md-button>
        </div>
        <div class="pencilDivAlt">
            <span v-if="routerPathName === 'Route'">
                <md-button v-if="pencilIconSelectedAlt" class="md-icon-button" title="Exit alternate path editor" @click="toggleRouteEditingAlt(false)">
                    <img class="pencilSelected" src="static/img/Alt_Pencil_Icon_on.png"/>
                </md-button>
                <md-button v-else class="md-icon-button" title="Enable alternate path editor" @click="toggleRouteEditingAlt(true)">
                    <img src="static/img/Alt_Pencil_Icon.png"/>
                </md-button>
            </span>
        </div>
        <div class="infopencilSelectedMy">
            <md-avatar>
                <img @click="showVideoPdf()" class="infopencilSelected" src="static/img/Help_Icon.png" style="height: auto !important;">
            </md-avatar>
        </div>
        <div class="circleRoute">
            <span v-if="routerPathName === 'Route'">
                <md-button v-if="circularToggle" class="md-icon-button" title="Hide TriggerZones" @click=" toggleRouteCircular(true) ; ">
                    <img src="static/img/Toggle-GPS-TriggerZONE-ON.png"/>
                </md-button>
                <md-button v-else class="md-icon-button" title="View TriggerZones" @click=" toggleRouteCircular(false);">
                    <img class="pencilSelected" src="static/img/Toggle-GPS-TriggerZONE-OFF.png"/>
                </md-button>
            </span>
        </div>
        <div class="pencilDiv">
            <span v-if="routerPathName === 'Route'">
                <md-button v-if="pencilIconSelected" class="md-icon-button" title="Exit path editor" @click="toggleRouteEditing(false)">
                    <img class="pencilSelected" src="static/img/Pencil_Icon_on.png"/>
                </md-button>
                <md-button v-else class="md-icon-button" title="Enable path editor" @click="toggleRouteEditing(true)">
                    <img src="static/img/Pencil_Icon.png"/>
                </md-button>
            </span>
        </div>
        <gmap-map :options="{scaleControl: true}" @idle="gettingBounds()" :center="center" :zoom="14" class="mapStyle" @click="createPath($event)" @center_changed="updateCenter($event)" @dragend="saveCenter()" ref="map">
            <span v-if="showTriggers" v-for="(trigger, index3) in triggersList" :key="index3">
                <span v-if="currentTriggerCheck(trigger)">
                    <gmap-polygon :zIndex="6" :paths="generateTriggerPolygonPaths(currentTrigger)" :draggable="false" :editable="false" :options="triggerZonePolygon"></gmap-polygon>
                    <gmap-polygon :zIndex="6" :paths="generateTriggerPolygonPathsComplete(currentTrigger)" :draggable="false" :editable="false" :options="triggerZonePolygonComplete"></gmap-polygon>
                    <gmap-marker :zIndex="8" :key="index3" :position="getParsedTriggerLatLng(currentTrigger)" :draggable="true" :clickable="true" :icon="currentTriggerPositionIcon" @drag="updateTriggerPoints($event)"></gmap-marker>
                    <gmap-marker v-if="headingEnabled" :zIndex="7" :key="index3" :position="getParsedTriggerLatLng(currentTrigger)" :icon="headingArrowShape(trigger)"></gmap-marker>
                    <gmap-marker v-if="headingEnabled" :zIndex="9" :key="index3" :position="headingRadiusHandlePosition" :draggable="true" :clickable="true" :icon="triggerEditIcon" @drag="updateHeadingRadius($event)"></gmap-marker>
                    <gmap-marker :zIndex="10" :key="index3" :position="tolerancePosition" :draggable="true" :clickable="true" :icon="triggerEditIcon" @drag="updateTolerance($event)" ref="toleranceHandle"></gmap-marker>
                </span>
                <span v-else-if="circularToggle">
                    <gmap-polygon :zIndex="6" :paths="generateTriggerPolygonPaths(trigger)" :draggable="false" :editable="false" :options="triggerZonePolygon"></gmap-polygon>
                    <gmap-polygon :zIndex="6" :paths="generateTriggerPolygonPathsComplete(trigger)" :draggable="false" :editable="false" :options="triggerZonePolygonComplete"></gmap-polygon>
                    <gmap-marker :zIndex="8" :key="index3" :position="getParsedTriggerLatLng(trigger)" :draggable="false" @click="loadTriggerSettings(trigger, index3)" :icon="currentTriggerPositionIcon" @drag="updateTriggerPoints($event)"></gmap-marker>
                    <gmap-marker :zIndex="5" @click="loadTriggerSettings(trigger, index3)" :key="index3" :position="getParsedTriggerLatLng(trigger)" :clickable="true" :icon="triggerPositionIcon(trigger)"></gmap-marker>
                    <gmap-marker v-if="parseFloat(trigger.tolerance) < 180" :zIndex="4" :key="index3" :position="getParsedTriggerLatLng(trigger)" :icon="headingArrowShape(trigger)"></gmap-marker>
                    <gmap-marker :zIndex="10" v-if="trigger.hovered" :key="index3" :position="getParsedTriggerLatLng(trigger)" :icon="triggerPositionIconHighlight"></gmap-marker>
                </span>
                <span v-else-if="!circularToggle">
                    <gmap-marker :zIndex="5" @click="loadTriggerSettings(trigger, index3)" :key="index3" :position="getParsedTriggerLatLng(trigger)" :clickable="true" :icon="triggerPositionIcon(trigger)" @mouseover="toggleInfoWindowNew(trigger,index3,true,false)" @mouseout="toggleInfoWindowNew(trigger,index3,false,false)"></gmap-marker>
                    <gmap-marker v-if="parseFloat(trigger.tolerance) < 180" :zIndex="4" :key="index3" :position="getParsedTriggerLatLng(trigger)" :icon="headingArrowShape(trigger)"></gmap-marker>
                    <gmap-info-window v-if="trigger.hovered" :options="infoOptions" :position="getParsedTriggerLatLng(trigger)" @closeclick="closeBox">{{ trigger.triggerName }}<br>
                        <span v-if="trigger.activate != 'Proximity'">
                            {{ trigger.activate }}
                        </span>
                        <br>
                        <span v-if="trigger.triggerMode != 'Queue'">
                            <span v-if="trigger.triggerMode  ==='Ignore'">
                                IGN
                            </span>
                            <span v-else>
                                INT
                            </span>
                        </span>
                        <br>Radius : {{ trigger.radiusDistance }}
                    </gmap-info-window>
                    <gmap-marker :zIndex="3" v-if="trigger.hovered" :key="index3" :position="getParsedTriggerLatLng(trigger)" :icon="triggerPositionIconHighlight"></gmap-marker>
                </span>
            </span>
            <span>
                <gmap-marker :zIndex="2" :key="index" v-for="(virtual, index) in topicsList" v-if="virtual.isReal===0 && topicAllChecks.includes(virtual.id)" :position="virtual.latLng" :clickable="true" :draggable="virtualTopicsMoveable" @dragend="updatePoints($event, virtual)" :icon="topicMarkerIcon(virtual)" @mouseover="toggleInfoWindow(virtual,index,true,false)" @mouseout="toggleInfoWindow(virtual,index,false,false)"></gmap-marker>
                <gmap-marker :zIndex="1" :key="index2" v-for="(topic, index2) in topicsList" v-if="topic.isReal===1 && topicAllCheck.includes(topic.id)" :position="topic.latLng" :clickable="true" :icon="topicMarkerIcon(topic)" @mouseover="toggleInfoWindow(topic,index2,true,false)" @mouseout="toggleInfoWindow(topic,index2,false,false)"></gmap-marker>
                <span v-if="currentTopic.name !== infoContent">
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="closeBox">{{ infoContent }}</gmap-info-window>
                </span>
	          </span>
            <span>
                <gmap-polyline :zIndex="11" :editable="routeEditingEnabled" :path="currentRoute.path" @rightclick="clickDeleteNode($event)" @path_changed="updatePath" :options="polyLine"></gmap-polyline>
                <gmap-polyline :zIndex="11" :editable="routeEditingEnabledAlt" :path="currentRouteAlt.alt_path" @rightclick="clickDeleteNodeAlt($event)" @path_changed="updatePathAlt" :options="polyLineAlt"></gmap-polyline>
          </span>
        </gmap-map>
        <div v-show="this.vertexToRemove !== null && pencilIconSelected" class="delete-parent" id="vertex-delete-parent" v-on:mouseleave="removeDeleteVertexBox" oncontextmenu="return false;">
            <div id="vertex-delete-shadow" class="delete-shadow"></div>
            <div id="vertex-delete-box" class="delete-button" @click="confirmDelete()">
                <div class="delete-text unselectable">DELETE</div>
            </div>
        </div>
        <div v-show="this.vertexToRemove !== null && pencilIconSelectedAlt" class="delete-parent" id="vertex-delete-parentAlt" v-on:mouseleave="removeDeleteVertexBoxAlt" oncontextmenu="return false;">
            <div id="vertex-delete-shadowAlt" class="delete-shadow"></div>
            <div id="vertex-delete-boxAlt" class="delete-button" @click="confirmDelete()">
                <div class="delete-text unselectable">DELETE</div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this Vertex?
            </md-dialog-content>
            <md-dialog-actions class="full-btn" v-if="pencilIconSelectedAlt">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteVertexAlt()">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
            <md-dialog-actions class="full-btn" v-if="pencilIconSelected">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteVertex()">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <modal name="hello-world" :resizable="true" :reset="true" height="60%" width="60%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
            <div class="row ">
                <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">clear</i>
                </button>
                <button @click="maxWindow()" type="button" class="minimize-icon">
                    <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important; height: 26px !important;"/>
                </button>
                <button @click="minWindow()" type="button" class="maximize-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">minimize</i>
                </button>
                <button @click="backList()" v-if="!listPanel" type="button" style="left: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close md-button md-icon-button">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">arrow_back</i>
                </button>
            </div>
            <div class="scroll-cont" v-if="listPanel">
                <div class="row">
                    <div class="col-4">
                        <div class="md-dialog-actions">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('homeActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    Video
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('infoActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    PDF
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('faqActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    FAQ
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row scroll-cont-wrap">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" id="home" v-show="isActiveTab('homeActive')">
                            <div id="videoList" class="vedionameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '0'"><a style="text-decoration: none !important;" v-on:click="showVedio(usermanual.id)"> <span style="padding-left:20px;"><i class="md-icon">videocam</i></span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('infoActive')">
                            <div id="pdfList" class="pdfnameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '1'"><a style="text-decoration: none !important;" v-on:click="showPdf(usermanual.id)"> <span style="padding-left:20px;"> <i class="md-icon">picture_as_pdf</i> </span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('faqActive')">
                            <div id="faqList" class="pdfnameList" v-if=showquestion>
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '2'"><a style="text-decoration: none !important; " v-on:click="showfaq(usermanual)"> <img class="pencilSelectedfaq" style="height: 20px; padding-left:20px;" src="static/img/Help_Icon-gr.png"> {{ usermanual.question }}</a>
                                    <p v-if="isHidden">{{ usermanual.answers }}</p>
                                </div>
                            </div>
                            <div id="faqList" class="pdfnameList" v-if=showquestiondetail>
                                <p><a style="text-decoration: none !important;" v-on:click="showfaqs(usermanual)"> <span style="padding-left:20px;"> <img class="pencilSelectedfaq" style="height: 20px;" src="static/img/Help_Icon-gr.png"> </span> {{ this.detailinfo.question }}</a></p>
                                <p style="text-decoration: none !important; margin-left: 65px; "><img class="pencilSelectedfaq" src="static/img/bulbicon.jpg" style="height: 20px;">{{ this.detailinfo.answers }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="logout-button conatinerForSupport">
                    <a href="https://www.listentech.com/listen-navilution-support/" target="_blank" class="GFG">
                        <button class="md-button md-theme-default" style="margin-bottom:10px; padding:10px;">
                            Website support
                        </button>
                    </a>
                    <md-button v-bind:href=" 'mailto:' + supportEmail" class="md-button md-theme-default">
                        Email support
                    </md-button>
                </div>
            </div>
            <div v-if="vedioPanel">
                <div class="row">
                    <div class="col-12">
                        <div data-v-ec680dbc="" class="md-dialog-actions ">
                            <button data-v-ec680dbc="" type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">Video</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pdfPanel">
                <div class="row">
                    <div class="col-12">
                        <div class="md-dialog-actions ">
                            <button type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">PDF</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <embed v-bind:src="this.pdfSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="hello-world2" :resizable="true" :reset="true" height="100%" width="100%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
            <div class="row ">
                <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">clear</i>
                </button>
                <button @click="maxWindow()" type="button" class="minimize-icon">
                    <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important; height: 26px !important;"/>
                </button>
                <button @click="minWindow()" type="button" class="maximize-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">minimize</i>
                </button>
                <button @click="backList()" v-if="!listPanel" type="button" style="left: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close md-button md-icon-button">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">arrow_back</i>
                </button>
            </div>
            <div class="scroll-cont" v-if="listPanel">
                <div class="row">
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('homeActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    Video
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('infoActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    PDF
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions full-btn">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('faqActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    FAQ
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row scroll-cont-wrap">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" id="home" v-show="isActiveTab('homeActive')">
                            <div id="videoList" class="vedionameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '0'"><a style="text-decoration: none !important;" v-on:click="showVedio(usermanual.id)"> <span style="padding-left:20px;"><i class="md-icon">videocam</i></span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('infoActive')">
                            <div id="pdfList" class="pdfnameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '1'"><a style="text-decoration: none !important;" v-on:click="showPdf(usermanual.id)"> <span style="padding-left:20px;"> <i class="md-icon">picture_as_pdf</i> </span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('faqActive')">
                            <div id="faqList" class="pdfnameList" v-if=showquestion>
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '2'"><a style="text-decoration: none !important; " v-on:click="showfaq(usermanual)"> <img class="pencilSelectedfaq" style="height: 20px; padding-left:20px;" src="static/img/Help_Icon-gr.png"> {{ usermanual.question }}</a>
                                    <p v-if="isHidden">{{ usermanual.answers }}</p>
                                </div>
                            </div>
                            <div id="faqList" class="pdfnameList" v-if=showquestiondetail>
                                <p><a style="text-decoration: none !important;" v-on:click="showfaqs(usermanual)"> <span style="padding-left:20px;"> <img class="pencilSelectedfaq" style="height: 20px;" src="static/img/Help_Icon-gr.png"> </span> {{ this.detailinfo.question }}</a></p>
                                <p style="text-decoration: none !important; margin-left: 65px; "><img class="pencilSelectedfaq" src="static/img/bulbicon.jpg" style="height: 20px;">{{ this.detailinfo.answers }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="vedioPanel">
                <div class="row">
                    <div class="col-12">
                        <div data-v-ec680dbc="" class="md-dialog-actions ">
                            <button data-v-ec680dbc="" type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">Video</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pdfPanel">
                <div class="row">
                    <div class="col-12">
                        <div class="md-dialog-actions ">
                            <button type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">PDF</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <embed v-bind:src="this.pdfSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script type="text/javascript">
import {mapState, mapGetters, mapActions} from 'vuex';
import {getUserManual} from '../../services/ClientService.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  watch: {
    $route (to, from) {
      this.circularToggle = false;
      if (to.path !== '/tour/route') {
        this.togglePencilIconSelectedAlt(false);
        this.togglePencilIconSelected(false);
      }
    }
  },
  data: function () {
    return {
      showDeleteDialog: false,
      deleteIndexVertex: '',
      isLoadingmy: false,
      isLoading: false,
      fullPage: true,
      isHidden: false,
      showquestion: true,
      showquestiondetail: false,
      circularToggle: false,
      reportedCenter: {
        latLng: {
          lat: null,
          lng: null
        }
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoOptions: {
        disableAutoPan: true,
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      topicPositionIcon: {
        url: 'static/svg/SEGMENT/TOI@2x.svg.svg'
      },
      topicPositionIconHighlight: {
        url: 'static/svg/SEGMENT/TOI_selected@2x.svg.svg'
      },
      virtualTopicPositionIcon: {
        url: 'static/svg/SEGMENT/Floating TOI@2x.svg.svg'
      },
      virtualTopicPositionIconHighlight: {
        url: 'static/svg/SEGMENT/Floating TOI_selected@2x.svg.svg'
      },
      currentTriggerPositionIcon: {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillColor: '#FFFFFF',
        fillOpacity: 1,
        scale: 0.1,
        strokeColor: '#007789',
        strokeWeight: 3
      },
      triggerPositionIconHighlight: {
        path: 'M-200,0a200,200 0 1,0 400,0a200,200 0 1,0 -400,0',
        fillColor: '#33DDFF',
        strokeWeight: 0,
        fillOpacity: 0.8,
        scale: 0.1
      },
      triggerZonePolygon: {
        strokeWeight: 0,
        strokeColor: 'rgb(85, 192, 228)',
        fillColor: '#08a8ca',
        fillOpacity: 0.725
      },
      triggerZonePolygonComplete: {
        strokeWeight: 2.0,
        strokeColor: 'rgb(85, 192, 228)',
        fillColor: '#FFFFFF',
        fillOpacity: 0
      },
      triggerEditIcon: {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillColor: '#007789',
        fillOpacity: 1,
        scale: 0.07,
        strokeColor: '#FFFFFF',
        strokeWeight: 1
      },
      polyLine: {
        strokeColor: '#00a6c9',
        strokeWeight: 2.5
      },
      polyLineAlt: {
        strokeColor: '#8D3D2B',
        strokeWeight: 2.5
      },
      activeTab: 'homeActive',
      errorMessage: null,
      clickedval: '',
      vedioSrc: '',
      pdfSrc: '',
      choice: 'homeActive',
      listPanel: true,
      vedioPanel: false,
      pdfPanel: false,
      topicAllCheck: [],
      topicAllChecks: [],
      UserManualList: [{
        id: '',
        attachment_name: '',
        type: '',
        path: ''
      }],
      isActive: '',
      resizeWidth: '60%',
      resizeHight: '60%',
      supportEmail: 'support@listentech.com',
      webSiteSupport: 'https://www.listentech.com/support/'
    };
  },
  components: {
    Loading
  },
  computed: {
    ...mapState({
      routerPathName: state => state.RouterModule.name
    }),
    ...mapGetters('user', ['currentUser']),
    ...mapGetters('map', ['pencilIconSelected', 'pencilIconSelectedAlt', 'center']),
    ...mapGetters('topics', ['currentTopic', 'topicsList']),
    ...mapGetters('routes', ['routesListLength', 'routesList', 'currentRoute', 'currentRouteAlt', 'vertexToRemove']),
    ...mapGetters('triggers', ['triggersList', 'currentTrigger', 'headingEnabled']),

    showTriggers () {
      var possibleRoutes = ['TopicTriggers', 'TopicNotes', 'TriggerSettings', 'TriggerNotes', 'Route'];
      return possibleRoutes.findIndex((element) => {
        return element === this.routerPathName;
      }) >= 0;
    },
    headingRadiusHandlePosition () {
      let latLng = new google.maps.LatLng({lat: parseFloat(this.currentTrigger.latLng.lat), lng: parseFloat(this.currentTrigger.latLng.lng)});
      return google.maps.geometry.spherical.computeOffset(latLng, this.currentTrigger.radiusDistance, (parseFloat(this.currentTrigger.heading) + 180));
    },
    tolerancePosition () {
      let toleranceHeading = (parseFloat(this.currentTrigger.heading) + 180) - (parseFloat(this.currentTrigger.tolerance) / 2);
      let baselatLng = new google.maps.LatLng(this.getParsedTriggerLatLng(this.currentTrigger));
      return google.maps.geometry.spherical.computeOffset(baselatLng, this.currentTrigger.radiusDistance, toleranceHeading);
    },
    routeEditingEnabled () {
      let editingEnabled = false;
      if (this.routerPathName === 'Route') {
        if (this.pencilIconSelected) {
          editingEnabled = true;
        }
      }
      return editingEnabled;
    },
    routeEditingEnabledAlt () {
      let editingEnabledAlt = false;
      if (this.routerPathName === 'Route') {
        if (this.pencilIconSelectedAlt) {
          editingEnabledAlt = true;
        }
      }
      return editingEnabledAlt;
    },
    virtualTopicsMoveable () {
      let moveable = false;
      if (this.routerPathName === 'TopicsTab') {
        moveable = true;
      }
      return moveable;
    },
    showRoutePath () {
      return (this.routerPathName !== 'TopicsTab' && this.routerPathName !== 'RoutesTab');
    }
  },
  methods: {
    ...mapActions('editor', ['toggleShowTriggerTabs']),
    ...mapActions('topics', ['loadEditorTopic', 'setMapHover']),
    ...mapActions('triggers', ['setMapHoverTrigger', 'updateCurrentTriggerLatLng', 'setCurrentTrigger', 'updateCurrentTriggerHeadingRadius', 'updateCurrentTriggerTolerance']),
    ...mapActions('routes', ['addCurrentPath', 'setUpdateCheck', 'setVertex', 'addCurrentPathAlt', 'setUpdateCheckAlt', 'setVertexAlt']),
    ...mapActions('map', ['togglePencilIconSelected', 'togglePencilIconSelectedAlt', 'setBounds', 'setBoundsAlt']),
    ...mapActions('user', ['setUserToEdit']),
    makeActive: function (val) {
      if (val === 'homeActive' && this.activeTab !== 'homeActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'homeActive';
      }
      if (val === 'infoActive' && this.activeTab !== 'infoActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'infoActive';
      }
      if (val === 'faqActive' && this.activeTab !== 'faqActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'faqActive';
      }
      this.choice = val;
    },
    maxWindow () {
      this.$modal.hide('hello-world');
      this.$modal.show('hello-world2');
    },
    minWindow () {
      this.$modal.show('hello-world');
      this.$modal.hide('hello-world2');
    },
    maxDo () {
      this.$modal.hide('hello-world');
      this.resizeWidth = '100%';
      this.resizeHight = '100%';
      this.$modal.show('hello-world');
    },
    async showVideoPdf () {
      this.$modal.show('hello-world');
      var result = await getUserManual();
      this.UserManualList = result.data;
      this.vedioPanel = false;
      this.pdfPanel = false;
    },
    closeshowVideoPdf () {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
    },
    showVedio (id) {
      window.open('#/usermanual/video?' + id, '_blank');
    },
    showPdf (id) {
      window.open('#/usermanual/pdf?' + id, '_blank');
    },
    showfaq (detailfaq) {
      this.showquestion = false;
      this.showquestiondetail = true;
      this.detailinfo = detailfaq;
    },
    showfaqs (detailfaq) {
      this.showquestion = true;
      this.showquestiondetail = false;
      this.detailinfo = detailfaq;
    },
    backList () {
      this.listPanel = true;
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.pdfSrc = '';
      this.vedioSrc = '';
    },
    isActiveTab: function (val) {
      return this.choice === val;
    },
    toggleInfoWindow (marker, index, toggle, center) {
      if (center) {
        this.$store.dispatch('map/setCenter', marker);
      } else {
        if (marker.orderInRoute) {
          this.$bus.$emit('scrollList', {topicIndex: marker.orderInRoute - 1, toggle: toggle});
        } else {
          this.$bus.$emit('scrollList', {topicIndex: index, toggle: toggle});
        }
      }
      this.infoWinOpen = false;
      this.infoWindowPos = marker.latLng;
      this.infoContent = marker.name;
      this.infoWinOpen = toggle;
      this.setMapHover([index, toggle]);
    },
    toggleInfoWindowNew (trigger, index, toggle, center) {
      if (center) {
        this.$store.dispatch('map/setCenter', trigger);
      }
      this.infoWinOpen = false;
      this.infoWindowPos = trigger.latLng;

      this.infoContent = 'Length - ' + trigger.file_length;
      if (trigger.file_length) {
        this.infoWinOpen = toggle;
      }
      this.setMapHoverTrigger([index, toggle]);
    },
    toggleRouteCircular (status) {
      this.isLoadingmy = true;
      setTimeout(() => {
        if (status === true) {
          this.circularToggle = false;
        } else {
          this.circularToggle = true;
        }
        this.isLoadingmy = false;
      }, 0);
    },
    closeBox () {
      this.infoWinOpen = false;
    },
    /*
                When the user clicks on the map, createPath is ran.
                It checks if clickHandler is true, which will determine if the user is at the TourRoute.vue component.
                It then checks if this is a new route with no path. If it is, it just assigns it an empty array value.
                It takes the currentRoute path, and adds the new vertice (e) to the path variable.
                  */
    createPath (e) {
      if (this.routeEditingEnabled) {
        var currentRoutePath = this.currentRoute.path;
        if (currentRoutePath === null) {
          currentRoutePath = [];
        }
        currentRoutePath.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
        this.addCurrentPath(currentRoutePath);
        this.setUpdateCheck(true);
        let listLength = this.routesListLength - 1;
        if (this.routesList[listLength].path === null || this.routesList[listLength].path === '') {
          this.routesList[listLength].path = [];
        }
        // this.routesList[listLength].path.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
      } else {
        this.createPathAlt(e);
      }
    },
    createPathAlt (e) {
      if (this.routeEditingEnabledAlt) {
        var currentRoutePathAlt = this.currentRouteAlt.alt_path;
        if (currentRoutePathAlt === null || currentRoutePathAlt === '') {
          currentRoutePathAlt = [];
        }
        currentRoutePathAlt.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
        this.addCurrentPathAlt(currentRoutePathAlt);
        this.setUpdateCheckAlt(true);
        let listLength = this.routesListLength - 1;
        if (this.routesList[listLength].alt_path === null || this.routesList[listLength].alt_path === '') {
          this.routesList[listLength].alt_path = [];
        }
        // this.routesList[listLength].alt_path.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
      }
    },
    gettingBounds () {
      this.setBounds(this.$refs.map.$mapObject.getBounds());
    },
    gettingBoundsAlt () {
      this.setBoundsAlt(this.$refs.map.$mapObject.getBoundsAlt());
    },
    /*
                When the center is changed on the map, newCenter is ran.
                It takes the new center coordinates (e), and dispatches it to the state to save it.
                  */
    updateCenter (e) {
      this.reportedCenter.latLng.lat = e.lat();
      this.reportedCenter.latLng.lng = e.lng();
    },

    saveCenter () {
      this.$store.dispatch('map/setCenter', this.reportedCenter);
    },

    /*
                When a virtual topic (virtual marker) is moved, updatePoints is ran.
                The new coordinates (e) is saved as the new coordinates for the virtual marker (virtual).
                Then a dispatch to topicsModule happens to assign true to virtualTopicCondition.
                This variable determines when a virtual marker is moved, and the change can be saved.
                  */
    updatePoints (e, virtual) {
      virtual.latLng.lat = e.latLng.lat();
      virtual.latLng.lng = e.latLng.lng();
      this.$store.dispatch('topics/toggleVirtualConditional', true);
      return virtual;
    },

    /*
                When a path is moved/edited, updatePath is ran. The new path (e) is saved,
                then is sent to routesModule to overwrite the previous currentRoute.
                After, setUpdateCheck is run to set the updateCheck condition to true. This lets the application
                know that a change has happened, and will make the Save button availible.
                  */
    updatePath (e) {
      if (this.routeEditingEnabled) {
        var currentRoutePath = [];
        for (var i = 0; i < e.getLength(); i++) {
          currentRoutePath.push({lat: e.getAt(i).lat(), lng: e.getAt(i).lng()});
        }
        this.addCurrentPath(currentRoutePath);
        this.setUpdateCheck(true);
      }
    },
    updatePathAlt (e) {
      if (this.routeEditingEnabledAlt) {
        var currentRoutePathAlt = [];
        for (var i = 0; i < e.getLength(); i++) {
          currentRoutePathAlt.push({lat: e.getAt(i).lat(), lng: e.getAt(i).lng()});
        }
        this.addCurrentPathAlt(currentRoutePathAlt);
        this.setUpdateCheckAlt(true);
      }
    },

    clickDeleteNode (event) {
      if (this.routeEditingEnabled && !(event.vertex === undefined)) {
        var latLng = new google.maps.LatLng({lat: this.currentRoute.path[event.vertex].lat, lng: this.currentRoute.path[event.vertex].lng});
        var map = this.$refs.map.$mapObject;
        var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        var point = new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);// google maps pixel location
        point.x += 302;
        point.y -= 38;
        var deleteBox = document.getElementById('vertex-delete-parent');
        deleteBox.style.left = point.x + 'px';
        deleteBox.style.top = point.y + 'px';
        this.setVertex(event.vertex);
      }
    },
    clickDeleteNodeAlt (event) {
      if (this.routeEditingEnabledAlt && !(event.vertex === undefined)) {
        var latLng = new google.maps.LatLng({lat: this.currentRouteAlt.alt_path[event.vertex].lat, lng: this.currentRouteAlt.alt_path[event.vertex].lng});
        var map = this.$refs.map.$mapObject;
        var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        var point = new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);// google maps pixel location
        point.x += 302;
        point.y -= 38;
        var deleteBox = document.getElementById('vertex-delete-parentAlt');
        deleteBox.style.left = point.x + 'px';
        deleteBox.style.top = point.y + 'px';
        this.setVertex(event.vertex);
      }
    },
    deleteVertex () {
      var currentRoutePath = this.currentRoute.path;
      currentRoutePath.splice(this.deleteIndexVertex, 1);
      this.addCurrentPath(currentRoutePath);
      this.setUpdateCheck(true);
      this.setVertex(null);
      this.showDeleteDialog = false;
    },
    deleteVertexAlt () {
      var currentRoutePathAlt = this.currentRoute.alt_path;
      currentRoutePathAlt.splice(this.deleteIndexVertex, 1);
      this.addCurrentPathAlt(currentRoutePathAlt);
      this.setUpdateCheckAlt(true);
      this.setVertexAlt(null);
      this.showDeleteDialog = false;
    },
    confirmDelete () {
      this.deleteIndexVertex = this.vertexToRemove;
      this.showDeleteDialog = true;
    },
    removeDeleteVertexBox () {
      this.setVertex(null);
    },
    removeDeleteVertexBoxAlt () {
      this.setVertex(null);
    },

    currentTriggerCheck (trigger) {
      var isCurrent = false;
      if (this.currentTrigger.id) {
        if (trigger.id === this.currentTrigger.id) {
          isCurrent = true;
        }
      }
      return isCurrent;
    },
    updateTriggerPoints (e) {
      var newLatLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      };
      this.updateCurrentTriggerLatLng(newLatLng);
    },
    // Opens sidebar settings for a trigger zone when it's map icon is clicked
    loadTriggerSettings (trigger, index) {
      this.circularToggle = false;
      // This initial if/else block checks to see if a current topic is set and if
      // it is the parent topic for the trigger zone selected, if not it sets the current topic
      let topic = null;
      if (this.currentTopic.id) {
        if (this.currentTopic.id !== trigger.toiId) {
          topic = this.getTopic(trigger.toiId);
        }
      } else {
        topic = this.getTopic(trigger.toiId);
      }
      if (topic !== null) {
        this.loadEditorTopic(topic);
      }

      this.setCurrentTrigger(trigger);
      this.toggleShowTriggerTabs(true);
      this.$router.push('/tour/trigger');
    },
    // Helper function for loadTriggerSettings
    getTopic (topicId) {
      for (let topic of this.topicsList) {
        if (topic.id === topicId) {
          return topic;
        }
      }
      return null;
    },
    topicMarkerIcon (topic) {
      if (topic.isReal === 0) {
        if (topic.selected || topic.id === this.currentTopic.id) {
          return this.virtualTopicPositionIconHighlight;
        }
        if (topic.hover || topic.mapHover) {
          return this.virtualTopicPositionIconHighlight;
        } else {
          return this.virtualTopicPositionIcon;
        }
      } else if (topic.isReal === 1) {
        if (topic.selected || topic.id === this.currentTopic.id) {
          return this.topicPositionIconHighlight;
        }
        if (topic.hover || topic.mapHover) {
          return this.topicPositionIconHighlight;
        } else {
          return this.topicPositionIcon;
        }
      }
    },
    generateTriggerPolygonPaths (trigger) {
      let polyPoints = [];
      let deltaHeading = (parseFloat(Math.round(trigger.tolerance)) / 2) / 50;
      let baselatLng = this.getParsedTriggerLatLng(trigger);

      polyPoints.push(baselatLng); // push in the base point first
      for (let ctr = 0; ctr <= 100; ctr++) {
        let polyPointHeading = (parseFloat(trigger.heading) + 180) - (parseFloat(Math.round(trigger.tolerance)) / 2) + deltaHeading * ctr;
        let latLng = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(baselatLng), parseFloat(trigger.radiusDistance), polyPointHeading);
        polyPoints.push({lat: latLng.lat(), lng: latLng.lng()});
      }
      return polyPoints;
    },
    generateTriggerPolygonPathsComplete (trigger) {
      let polyPoints = [];
      let deltaHeading = (parseFloat(Math.round(trigger.tolerance)) / 2) / 50;
      let baselatLng = this.getParsedTriggerLatLng(trigger);

      polyPoints.push(baselatLng); // push in the base point first
      for (let ctr = 100; ctr <= 36000; ctr++) {
        let polyPointHeading = (parseFloat(trigger.heading) + 180) - (parseFloat(Math.round(trigger.tolerance)) / 2) + deltaHeading * ctr;
        let latLng = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(baselatLng), parseFloat(trigger.radiusDistance), polyPointHeading);
        polyPoints.push({lat: latLng.lat(), lng: latLng.lng()});
      }
      return polyPoints;
    },
    getParsedTriggerLatLng (trigger) {
      return {lat: parseFloat(trigger.latLng.lat), lng: parseFloat(trigger.latLng.lng)};
    },
    headingArrowShape (trigger) {
      let heading = parseFloat(trigger.heading);
      let icon = {};
      if (isNaN(heading)) {
        heading = 0.00;
      } else {
        icon = {
          path: 'm0.19672,-15.70492l-7.5,18.29l0.71,0.71l6.79,-3l6.79,3l0.71,-0.71l-7.5,-18.29z',
          fillOpacity: 1,
          strokeWeight: 1,
          scale: 1.4
        };
        if (this.currentTriggerCheck(trigger)) {
          icon.strokeColor = '#007789';
          icon.rotation = parseFloat(this.currentTrigger.heading);
        } else {
          icon.strokeColor = '#FFFFFF';
          icon.rotation = heading;
        }
        if (trigger.toiId === this.currentTopic.id) {
          icon.fillColor = '#007789';
        } else {
          icon.fillColor = '#00a6c9';
        }
      }
      return icon;
    },
    updateHeadingRadius (e) {
      let newLatLng = new google.maps.LatLng({lat: e.latLng.lat(), lng: e.latLng.lng()});
      let currentlatLng = new google.maps.LatLng({lat: parseFloat(this.currentTrigger.latLng.lat), lng: parseFloat(this.currentTrigger.latLng.lng)});

      let newRadius = google.maps.geometry.spherical.computeDistanceBetween(currentlatLng, newLatLng);
      newRadius = Math.round(newRadius * 100) / 100;

      let newHeading = 0;
      if (this.headingEnabled) {
        newHeading = google.maps.geometry.spherical.computeHeading(currentlatLng, newLatLng);
        newHeading = (newHeading + 180) % 360;
        newHeading = Math.round(newHeading * 100) / 100;
      } else {
        newHeading = parseFloat(this.currentTrigger.heading);
      }

      this.updateCurrentTriggerHeadingRadius({heading: String(newHeading), radius: newRadius});
    },
    updateTolerance (e) {
      let newLatLng = new google.maps.LatLng({lat: e.latLng.lat(), lng: e.latLng.lng()});
      let currentBaselatLng = new google.maps.LatLng(this.getParsedTriggerLatLng(this.currentTrigger));

      let newToleranceHeading = google.maps.geometry.spherical.computeHeading(currentBaselatLng, newLatLng);
      let currentHeading = (parseFloat(this.currentTrigger.heading) + 180) % 360;
      let newTolerance = (Math.abs(newToleranceHeading - currentHeading) + 360) % 360;

      newTolerance = newTolerance * 2;
      newTolerance = Math.round(newTolerance * 100) / 100;

      this.updateCurrentTriggerTolerance(newTolerance);
    },
    toggleRouteEditing (toggle) {
      this.togglePencilIconSelected(toggle);
      this.togglePencilIconSelectedAlt(false);
    },
    toggleRouteEditingAlt (toggle) {
      this.togglePencilIconSelectedAlt(toggle);
      this.togglePencilIconSelected(false);
    },
    triggerPositionIcon (trigger) {
      let icon = {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillOpacity: 1,
        scale: 0.1,
        strokeColor: '#FFFFFF',
        strokeWeight: 1.5
      };

      if (trigger.toiId === this.currentTopic.id) {
        icon.fillColor = '#007789';
      } else {
        icon.fillColor = '#00a6c9';
      }

      return icon;
    },
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials (user) {
      let userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    }
  },
  beforeMount () {
    if (this.topicsList.length !== 0) {
      this.isLoading = true;
      for (let index = 0; index < this.topicsList.length; index++) {
        const element = this.topicsList[index].id;
        this.topicAllCheck.push(element);
        this.isLoading = false;
      }
    }
    if (this.topicsList.length !== 0) {
      this.isLoading = true;
      for (let index = 0; index < this.topicsList.length; index++) {
        const elements = this.topicsList[index].id;
        this.topicAllChecks.push(elements);
        this.isLoading = false;
      }
    }
    if (this.topicsList.length === 0) {
      this.isLoading = false;
    }
    this.$bus.$off('hoveredTopic');
  },
  mounted () {
    this.$bus.$on('hoveredTopic', ($params) => {
      this.toggleInfoWindow(this.topicsList[$params.topicIndex], $params.topicIndex, $params.toggle, true);
    });
    this.togglePencilIconSelectedAlt(false);
    this.togglePencilIconSelected(false);
  }
};
</script>
<style type="scss">
.logout-button {
    padding-top: 13.5px;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.logout-button .md-button:hover {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.conatinerForSupport {
    position: absolute;
    bottom: 0;
}

.mapDiv {
    min-height: 500px;
    height: 100vh !important;
    width: calc(100% - 344px);
    float: right;
    z-index: 1;
}

.mapStyle {
    width: 100%;
    height: 100%;
}

.mapDiv .pencilDisabled {
    filter: brightness(50%);
}

.mapDiv .pencilDiv {
    position: absolute;
    z-index: 2;
    left: calc(100% - 192px);
    top: -3px;
}

.mapDiv .circleRoute {
    position: absolute;
    z-index: 2;
    left: calc(100% - 238px);
    top: -3px;
}

.gm-style-iw {
    padding-left: 12px;
}

.gm-style-iw + div {
    display: none;
}

.mapDiv .map-header-avatar {
    position: absolute;
    z-index: 2;
    left: calc(100% - 90px);
    top: 3px;
}

.mapDiv .infopencilSelectedMy {
    position: absolute;
    z-index: 2;
    left: calc(100% - 145px);
    top: 0;

}

.mapDiv .infopencilSelectedMy .md-avatar {
    width: 48px;
}

img.infopencilSelected {
    max-width: 32px;
    height: auto;
}

.mapDiv .map-header-avatar .md-button {
    height: 40px;
    width: 40px;
    min-width: 40px !important;
    margin: 0;
}

.mapDiv .map-header-avatar .md-avatar.md-theme-default.md-avatar-icon {
    background-color: #7F7F7F !important;
}

.avatar-button {
    font-weight: 300 !important;
}

.delete-button {
    cursor: pointer;
    position: absolute;
    left: 9px;
    top: 9px;
    width: 65px;
    height: 21px;
    border-radius: 2px;
    background-color: rgb(255, 255, 255);
}

.delete-shadow {
    position: absolute;
    width: 67px;
    height: 23px;
    left: 8px;
    top: 8px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
}

.delete-parent {
    position: absolute;
    display: block;
    width: 86px;
    height: 44px;
}

.delete-text {
    padding: 0px 12px;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.mapDiv .circleRoute {
    position: absolute;
    z-index: 2;
    left: calc(100% - 238px);
    top: -3px;
}

.md-dialog-actions {
    padding: 0px 0px 0px 1px !important;
}

.v--modal-box.v--modal .col-6 {
    padding: 0 !important;
    overflow: auto;
}

.v--modal-overlay .v--modal-box {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    top: 0px;
    left: 383px;
    width: 800px;
    height: 900px;
}

.infopencilSelected {
    cursor: pointer;
    width: 70%;
    margin-top: 4%;
}

.vedionameList {
    padding-left: 4% !important;
    padding-top: 10px;
}

.pdfnameList {
    padding-left: 6%;
    padding-top: 10px;
}

.Usemanual-list-front {
    width: 100% !important;
    height: 62px !important;
}

.redActiveManual {
    border-bottom: 3px solid #08a8ca !important;
}

.fontManualTab {
    color: #08a8ca;
}

.close-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 0px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.minimize-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 37px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.maximize-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 74px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.scroll-cont {
    height: 100%;
    padding: 0 24px;
}

.scroll-cont-wrap {
    max-height: calc(100% - 62px);
    overflow: auto;
}

.mapDiv .pencilDivAlt {
    position: absolute;
    z-index: 2;
    left: calc(100% - 282px);
    top: -3px;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/GoogleMaps.vue